export const FIELD_MAPPINGS = {
  period: 'periodName',
  companycode: 'companyCode',
  description: 'ccDescription',
  enabledflag: 'enabledFlag',
  legalentity: 'legalEntity',
  businessunit: 'businessUnit',
  chartname: 'chartName',
  connectionname: 'connName',
  associatedlecountrycode: 'associatedLeCountryCode',
  associatedlegoldid: 'associatedLeGoldId',
  functionalcurrency: 'functionalCurrency',
  overridetaxcurrency: 'overrideTaxCurrency',
  homeofficecompanycode: 'homeOfficeCompanyCode',
  homeofficecountrycode: 'homeOfficeCountryCode',
  recordftc: 'recordFTC',
  usshareholderflag: 'usShareholderFlag',
  businesscode: 'businessCode',
  businessdescription: 'businessDescription',
  ledgerid: 'ledgerId',
  ledgershortname: 'ledgerShortName',
  source: 'source',
  bsmflag: 'subledgerFlag',
  statcalcflag: 'statCalc',
  statcurrency: 'statCurrency',
  costcenter: 'costCenter',
  project: 'project',
  reference: 'reference',
  productline: 'productLine',
  profitcenter: 'profitCenter',
  ledgeridin: 'ledgerIdIn',
  ledgeridout: 'ledgerIdOut',
  legalentityoverride: 'leOverride',
  companycodeoverride: 'ccOverride',
  allowjournals: 'jeFlag',
};

export const MIN_COLUMNS_NUMBER = 34;
export const MAX_COLUMNS_NUMBER = 34;
